import { CustomAlert } from '@planning/pages/TallymanV2/Components'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

export const ContainerAlreadyAssigned: FC = () => {
  const { t } = useTranslate()
  return (
    <CustomAlert
      message={t(
        'thisContainerHasAlreadyBeenAssignedToAJourneyForThisTruckVisitPleaseReviewTheExistingAssignment',
        'This container has already been assigned to a journey for this truck visit. Please review the existing assignment.',
      )}
      severity='warning'
    />
  )
}
